module.exports = __webpack_public_path__ + "d73febfe55288bfb8445db5b3f232d52.png";